// extracted by mini-css-extract-plugin
export var attachment = "_my-a";
export var emailContainer = "_my-4";
export var emailContentPaddedContainer = "_my-b";
export var emailHeader = "_my-6";
export var emailIframe = "_my-3";
export var emailInfoIcon = "_my-9";
export var emailShortenedSummary = "_my-e";
export var infoDropdown = "_my-0";
export var infoRowBoundedContent = "_my-d";
export var internal = "_my-5";
export var merchant = "_my-8";
export var messageInputContainer = "_my-h";
export var normal = "_my-7";
export var replyCard = "_my-f";
export var subtleButton = "_my-1";
export var subtleButtonIconContainer = "_my-2";
export var toggleViewRepliesButton = "_my-c";
export var wrappingText = "_my-g";